"use client";

import { useEffect } from "react";
import { setCourseGAContext } from "~/utils/googleAnalyticsUtils";

type Props = {
  courseId?: string;
  courseName?: string;
  measurementId?: string | null;
  showEnhancedEvents?: boolean;
};

/**
 * Keeps the module-level course context in googleAnalyticsUtils in sync with the
 * currently mounted course, so plain googleAnalyticsEvent() calls (Buy, Pay,
 * Place Offer, filters, etc.) automatically carry course_id / course_name and
 * are scoped to that course's GA property. Resets on unmount (e.g. when leaving
 * a course for the facility page) so events there aren't tagged with a stale
 * course.
 *
 * Takes course fields as props (fed from courseData in the layout) rather than
 * reading the merged CourseContext, which is undefined until course images also
 * load — that would otherwise drop course_id/course_name from events.
 */
const CourseGAContextSync = ({
  courseId,
  courseName,
  measurementId,
  showEnhancedEvents,
}: Props) => {
  useEffect(() => {
    setCourseGAContext({ courseId, courseName, measurementId, showEnhancedEvents });
    return () => setCourseGAContext({});
  }, [courseId, courseName, measurementId, showEnhancedEvents]);

  return null;
};

export default CourseGAContextSync;
